import { Box, H1, Separator, Text } from '@betterment/samba-react';

import { TermsAndAgreements } from '../../../graphql/schema';

export const TermsAndAgreementsBlock: React.FC<{ termsAndAgreement: TermsAndAgreements }> = ({ termsAndAgreement }) => {
  return (
    <Box
      css={{
        border: '1px solid',
        borderColor: 'border',
        borderRadius: 'medium',
        padding: 'space.200',
      }}
    >
      <H1 variant="title100">{termsAndAgreement.title}</H1>
      <Separator css={{ my: 'space.200' }} />
      <Text
        dangerouslySetInnerHTML={{ __html: termsAndAgreement.terms }}
        css={{
          '& ul': {
            listStyleType: 'disc',
            paddingLeft: 'space.300',
            margin: 'space.0',
          },
          '& li': {
            marginBottom: 'space.100',
          },
        }}
      />
    </Box>
  );
};
